import { Component } from '@angular/core';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { NavController, NavParams, ModalController, ViewController } from 'ionic-angular';
import * as moment from 'moment';

import { Data } from '../../providers/providers';

@Component({
  selector: 'page-spray-record-edit',
  templateUrl: 'spray-record-edit.html'
})
export class SprayRecordEditPage {

  isReadyToSave: boolean;
  sprayRecord: any;
  form: FormGroup;

  constructor(public navCtrl: NavController,
              public modalCtrl: ModalController,
              public viewCtrl: ViewController,
              public navParams: NavParams,
              formBuilder: FormBuilder,
              public data: Data)
  {
    this.sprayRecord = this.navParams.get('sprayRecord');

    if (!this.sprayRecord) {
      this.sprayRecord = {
        id: "",
        date: moment().format('YYYY-MM-DD'),
        stage: "",
        chemical: ""
      };
    }

    this.form = formBuilder.group({
      id: [this.sprayRecord.id, null], // not shown in view
      date: [this.sprayRecord.date, Validators.required],
      stage: [this.sprayRecord.stage],
      chemical: [this.sprayRecord.chemical],
    });

    this.updateReadyToSave();
    // Watch the form for changes, and
    this.form.valueChanges.subscribe((v) => {
      this.updateReadyToSave();
    });
  }

  updateReadyToSave() {
    this.isReadyToSave = this.form.valid;
  }

  /**
   * The user cancelled, so we dismiss without sending data back.
   */
  cancel() {
    this.viewCtrl.dismiss();
  }

  /**
   * The user is done and wants to create the item, so return it
   * back to the presenter.
   */
  done() {
    if (!this.form.valid) { return; }
    this.viewCtrl.dismiss(this.form.value);
  }
}



// WEBPACK FOOTER //
// ./src/pages/spray-record-edit/spray-record-edit.ts